export default function SkeletonCard() {
  return (
    <div className="skeleton-card">
      <div className="skeleton-card__thumb shimmer" />
      <div className="skeleton-card__body">
        <div className="skeleton-line skeleton-line--80 shimmer" />
        <div className="skeleton-line skeleton-line--60 shimmer" />
        <div className="skeleton-line skeleton-line--40 shimmer" />
      </div>
    </div>
  );
}
